// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vue-node_modules_pnpm_vue_2_7_14_node_modules_vue_dist_vue_esm_js","defaultVendors-node_modules_pnpm_vue-loader_15_11_1_css-loader_6_7_3_webpack_5_107_2__lodash_-702ba0"], function() { return __webpack_require__("./app/views/next/home/index.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
